module.exports = __webpack_public_path__ + "static/media/29ADMSPC23.bd84889c.jpg";